import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButton } from 'Wpds/components/button';
import OnboardingSlackTitle from './OnboardingSlackTitle';

// Styles
import './OnboardingSlackAINextMeeting.scss';

const OnboardingSlackAINextMeeting = () => {
  const {
    onboardingState,
    isAdvancingForward,
    handleAdvanceOnboardingState,
    handleAdvanceBackOnboardingState,
  } = useOnboardingState();

  const [workspaceName, setWorkspaceName] = useState('');
  const [hasError, toggleHasError] = useToggle(false);

  const handleInputOnChange = value => {
    setWorkspaceName(value);
    if (hasError) toggleHasError();
  };

  const handleNextClick = () => {
    if (workspaceName.trim() === '') {
      toggleHasError();
      return;
    }

    handleAdvanceOnboardingState({
      onboardingState: {
        workspaces: [
          {
            uuid: uuidv4(),
            name: workspaceName,
          },
        ],
      },
    });
  };

  useEffect(() => {
    const workspaceName = onboardingState?.workspaces[0]?.name;
    if (workspaceName) setWorkspaceName(workspaceName);
  }, []);

  const baseClassName = 'OnboardingSlackAINextMeeting';

  return (
    <div className={baseClassName}>
      <OnboardingSlackTitle title="Choose Meeting" onBack={handleAdvanceBackOnboardingState} />
      <div>
        <p className={`${baseClassName}__desription`}>
          Use AgendaAI to suggest a meeting agenda for your next meeting.
        </p>
        <div className={`${baseClassName}__meeting-input`}>
          <WpTextField
            id="next_meeting"
            label="What's your next meeting?"
            placeholder="Ex: John & Sami 1:1, Weekly Sync"
            value={workspaceName}
            onChange={handleInputOnChange}
            error={hasError && 'Please add meeting'}
          />
        </div>
        <div className={`${baseClassName}__button`}>
          <WpButton block size="lg" onClick={handleNextClick} loading={isAdvancingForward}>
            Next
          </WpButton>
        </div>
      </div>
    </div>
  );
};

export default OnboardingSlackAINextMeeting;
